/* FLORE AJAX cart + slide-in drawer. Controls update immediately; Shopify's
   rendered response remains the source of truth for money and discounts. */
(function () {
  'use strict';

  var busy = false;
  var pendingFocus = null;
  var queuedMutations = [];
  var mutationRunning = false;
  var latestSectionHtml = null;
  var latestCartData = null;
  var completedCallbacks = [];
  var refreshSerial = 0;
  var checkoutAfterUpdate = false;

  /* Section Rendering API needs the full section id (with the group hash),
     e.g. "sections--123__flore_cart". Read it off the live DOM wrapper. */
  function sectionId() {
    var el = document.getElementById('flore-cart');
    var wrap = el && el.closest('[id^="shopify-section-"]');
    return wrap ? wrap.id.replace('shopify-section-', '') : 'flore_cart';
  }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function root() { return $('[data-flore-cart-root]'); }
  function panel() { return $('#flore-cart'); }
  function backdrop() { return $('.flore-cart-backdrop'); }
  function shopRoot() { return window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/'; }

  function lockScroll(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  function open() {
    var p = panel(); if (!p) return;
    p.classList.add('open');
    p.setAttribute('aria-hidden', 'false');
    if (backdrop()) backdrop().hidden = false;
    document.documentElement.classList.add('flore-cart-open');
    lockScroll(true);
    var f = p.querySelector('button, a, [tabindex]');
    if (f) try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); }
  }

  function close() {
    var p = panel(); if (!p) return;
    p.classList.remove('open');
    p.setAttribute('aria-hidden', 'true');
    if (backdrop()) backdrop().hidden = true;
    document.documentElement.classList.remove('flore-cart-open');
    lockScroll(false);
  }

  function isOpen() { var p = panel(); return p && p.classList.contains('open'); }

  function setBusy(on) {
    busy = on;
    var p = panel();
    if (!p) return;
    p.classList.toggle('is-busy', on);
    p.setAttribute('aria-busy', on ? 'true' : 'false');
    $all('[data-flore-cart-change], [data-flore-cart-checkout]', p).forEach(function (button) {
      button.disabled = on;
    });
  }

  function updateCount(n) {
    var live = $('[data-flore-cart-inner]');
    if (live) live.setAttribute('data-count', n);
    $all('[data-flore-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !(n > 0);
    });
    var title = $('.flore-cart-title', panel());
    if (title && title.dataset.cartHeading) title.textContent = title.dataset.cartHeading + (n > 0 ? ' · ' + n : '');
  }

  function status(message) {
    var el = $('[data-flore-cart-status]', panel());
    if (el) {
      el.textContent = message || '';
      el.hidden = !message;
    }
  }

  function discountFeedback(message, isError) {
    var feedback = $('[data-flore-cart-discount-feedback]', panel());
    if (!feedback) return;
    feedback.textContent = message || '';
    feedback.hidden = !message;
    feedback.classList.toggle('is-error', !!isError);
  }

  function discountCodes() {
    return $all('[data-flore-cart-discount-code]', panel()).map(function (item) {
      return item.dataset.floreCartDiscountCode;
    }).filter(Boolean);
  }

  function syncDiscountCodes(data) {
    if (!data || !Array.isArray(data.discount_codes)) return;
    var list = $('[data-flore-cart-discount-codes]', panel());
    if (!list) return;
    var codes = data.discount_codes.filter(function (item) { return item && item.applicable; });
    var current = discountCodes();
    if (codes.length === current.length && codes.every(function (item, index) {
      return item.code.toLowerCase() === current[index].toLowerCase();
    })) return;
    list.replaceChildren();
    codes.forEach(function (item) {
      var li = document.createElement('li');
      li.dataset.floreCartDiscountCode = item.code;
      var label = document.createElement('span');
      label.textContent = item.code;
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.setAttribute('data-flore-cart-discount-remove', '');
      remove.setAttribute('aria-label', 'Remove discount ' + item.code);
      remove.textContent = '×';
      li.append(label, remove);
      list.appendChild(li);
    });
  }

  function optimisticCount(delta) {
    var live = $('[data-flore-cart-inner]');
    updateCount(Math.max(0, parseInt(live && live.getAttribute('data-count') || '0', 10) + delta));
  }

  function planPrice(variantId, quantity) {
    var plans = $all('[data-pdp-plan]').filter(function (item) {
      return item.dataset.variant === String(variantId);
    });
    var plan = plans.find(function (item) {
      return item.dataset.variant === String(variantId) && parseInt(item.dataset.quantity, 10) === quantity;
    });
    if (!plan && plans.length) {
      var largest = plans.reduce(function (best, item) {
        return !best || Number(item.dataset.quantity) > Number(best.dataset.quantity) ? item : best;
      }, null);
      if (largest && quantity > Number(largest.dataset.quantity)) {
        var largestTotal = moneyCents(largest.dataset.total);
        var largestQuantity = Number(largest.dataset.quantity);
        var unitCents = Number(largest.dataset.unitCents);
        if (largestTotal !== null && largestQuantity > 0 && unitCents > 0) {
          var bundleSaving = Math.max(0, unitCents * largestQuantity - largestTotal);
          return unitCents * quantity - bundleSaving;
        }
      }
    }
    return plan ? moneyCents(plan.dataset.total) : null;
  }

  function moneyCents(value) {
    if (!value) return null;
    var number = String(value).replace(/[^\d.,-]/g, '');
    var decimal = Math.max(number.lastIndexOf('.'), number.lastIndexOf(','));
    if (decimal < 0) return Number(number) * 100;
    var whole = number.slice(0, decimal).replace(/[.,]/g, '');
    var fraction = number.slice(decimal + 1);
    if (!/^\d{1,2}$/.test(fraction)) return null;
    return Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
  }

  function money(cents) {
    var live = $('[data-flore-cart-inner]');
    var currency = live && live.dataset.currency || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function moneyDisplayMatches(live, fresh) {
    if (!live || !fresh) return false;
    var liveOriginal = $('s', live);
    var freshOriginal = $('s', fresh);
    if ((liveOriginal && liveOriginal.textContent.trim()) !== (freshOriginal && freshOriginal.textContent.trim())) return false;
    function finalText(element) {
      var original = $('s', element);
      return element.textContent.replace(original ? original.textContent : '', '').trim();
    }
    return finalText(live) === finalText(fresh);
  }

  function setMoneyDisplay(element, originalCents, finalCents, wrapFinal) {
    if (!element) return;
    var original = originalCents > finalCents ? money(originalCents) : null;
    var finalPrice = money(finalCents);
    var currentOriginal = $('s', element);
    var currentFinal = element.textContent.replace(currentOriginal ? currentOriginal.textContent : '', '').trim();
    if ((currentOriginal && currentOriginal.textContent.trim()) === original && currentFinal === finalPrice) return;
    var children = [];
    if (original) {
      var strike = document.createElement('s');
      strike.textContent = original;
      children.push(strike, document.createTextNode(' '));
    }
    if (wrapFinal) {
      var span = document.createElement('span');
      span.textContent = finalPrice;
      children.push(span);
    } else children.push(document.createTextNode(finalPrice));
    element.replaceChildren.apply(element, children);
  }

  function optimisticSubtotal() {
    var live = $('[data-flore-cart-inner]');
    if (!live) return;
    var lines = $all('.flore-cart-line:not([hidden])', live);
    if (!lines.length) return;
    var original = 0;
    var finalPrice = 0;
    for (var i = 0; i < lines.length; i++) {
      var lineOriginal = Number(lines[i].dataset.originalLineCents);
      var lineFinal = Number(lines[i].dataset.finalLineCents);
      if (!Number.isFinite(lineOriginal) || !Number.isFinite(lineFinal)) return;
      original += lineOriginal;
      finalPrice += lineFinal;
    }
    var foot = $('.flore-cart-foot', live);
    if (!foot) return;
    setMoneyDisplay($('.flore-cart-subtotal-val', foot), original, finalPrice, false);
    var savings = $('.flore-cart-saved', foot);
    if (original > finalPrice) {
      if (!savings) {
        savings = document.createElement('div');
        savings.className = 'flore-cart-saved';
        var fineprint = $('.flore-cart-fineprint', foot);
        if (fineprint) fineprint.before(savings);
      }
      if (savings) {
        savings.textContent = 'You save ' + money(original - finalPrice);
        savings.hidden = false;
      }
    } else if (savings) savings.hidden = true;
  }

  function optimisticPrice(line, variantId, quantity) {
    if (!line) return;
    var finalCents = planPrice(variantId, quantity);
    var unitCents = Number(line.dataset.originalUnitCents);
    if (finalCents === null || !Number.isFinite(unitCents) || unitCents <= 0) return;
    var originalCents = unitCents * quantity;
    line.dataset.originalLineCents = originalCents;
    line.dataset.finalLineCents = finalCents;
    setMoneyDisplay($('.flore-cart-line-price', line), originalCents, finalCents, true);
    optimisticSubtotal();
  }

  function optimisticEmpty() {
    var live = $('[data-flore-cart-inner]');
    if (!live || $all('.flore-cart-line:not([hidden])', live).length) return;
    var list = $('.flore-cart-lines', live);
    if (list) list.hidden = true;
    var foot = $('.flore-cart-foot', live);
    if (foot) foot.hidden = true;
    if ($('.flore-cart-empty', live)) return;
    var template = $('[data-flore-cart-empty-template]', live);
    var empty = template && template.content.firstElementChild && template.content.firstElementChild.cloneNode(true);
    if (!empty) {
      empty = document.createElement('div');
      empty.className = 'flore-cart-empty';
      var message = document.createElement('p');
      message.textContent = live.dataset.emptyText || 'Your cart is empty.';
      empty.appendChild(message);
    }
    live.appendChild(empty);
  }

  function optimisticAddLine(variantId, quantity, product) {
    var live = $('[data-flore-cart-inner]');
    if (!live) return null;
    var matching = $all('.flore-cart-line', live).find(function (line) {
      return line.dataset.variantId === String(variantId);
    });
    if (!matching && (!product || !product.title)) return null;
    var empty = $('.flore-cart-empty', live);
    if (empty) empty.remove();
    var list = $('.flore-cart-lines', live);
    if (list) list.hidden = false;
    var foot = $('.flore-cart-foot', live);
    if (foot) foot.hidden = false;
    if (matching) {
      var shown = $('[data-qty]', matching);
      var current = matching.hidden ? 0 : parseInt(shown && shown.textContent || '0', 10) || 0;
      matching.hidden = false;
      if (shown) shown.textContent = current + quantity;
      return matching;
    }
    if (!list) {
      list = document.createElement('ul');
      list.className = 'flore-cart-lines';
      list.setAttribute('role', 'list');
      live.appendChild(list);
    }
    var line = document.createElement('li');
    line.className = 'flore-cart-line';
    line.dataset.variantId = String(variantId);
    line.dataset.pending = 'true';
    line.dataset.originalUnitCents = product.unitCents || '';
    var thumb = document.createElement('span');
    thumb.className = 'flore-cart-thumb';
    if (product.image) {
      var image = document.createElement('img');
      image.src = product.image;
      image.alt = product.title;
      image.width = 80;
      image.height = 80;
      thumb.appendChild(image);
    }
    var main = document.createElement('div');
    main.className = 'flore-cart-line-main';
    var title = document.createElement('span');
    title.className = 'flore-cart-line-title';
    title.textContent = product.title;
    var controls = document.createElement('div');
    controls.className = 'flore-cart-line-controls';
    var quantityControl = document.createElement('div');
    quantityControl.className = 'flore-qty';
    var decrease = document.createElement('button');
    decrease.type = 'button';
    decrease.textContent = '−';
    decrease.setAttribute('aria-label', 'Decrease quantity');
    decrease.setAttribute('data-flore-cart-change', '');
    decrease.setAttribute('data-flore-cart-op', 'decrease');
    decrease.setAttribute('data-key', String(variantId));
    var number = document.createElement('span');
    number.setAttribute('data-qty', '');
    number.textContent = quantity;
    var increase = document.createElement('button');
    increase.type = 'button';
    increase.textContent = '+';
    increase.setAttribute('aria-label', 'Increase quantity');
    increase.setAttribute('data-flore-cart-change', '');
    increase.setAttribute('data-flore-cart-op', 'increase');
    increase.setAttribute('data-key', String(variantId));
    quantityControl.append(decrease, number, increase);
    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'flore-cart-remove';
    remove.textContent = 'Remove';
    remove.setAttribute('data-flore-cart-change', '');
    remove.setAttribute('data-flore-cart-op', 'remove');
    remove.setAttribute('data-key', String(variantId));
    controls.append(quantityControl, remove);
    main.append(title, controls);
    var price = document.createElement('div');
    price.className = 'flore-cart-line-price';
    price.textContent = product.total || '';
    line.append(thumb, main, price);
    list.appendChild(line);
    if (!foot) {
      var footTemplate = $('[data-flore-cart-foot-template]', live);
      foot = footTemplate && footTemplate.content.firstElementChild && footTemplate.content.firstElementChild.cloneNode(true);
      if (foot) {
        var subtotalValue = $('.flore-cart-subtotal-val', foot);
        if (subtotalValue) subtotalValue.textContent = product.total || '';
        live.appendChild(foot);
      }
    }
    return line;
  }

  function patchLine(line, freshLine) {
    line.dataset.key = freshLine.dataset.key;
    line.dataset.variantId = freshLine.dataset.variantId;
    line.dataset.originalUnitCents = freshLine.dataset.originalUnitCents;
    line.dataset.originalLineCents = freshLine.dataset.originalLineCents;
    line.dataset.finalLineCents = freshLine.dataset.finalLineCents;
    line.hidden = false;
    delete line.dataset.pending;
    var thumb = $('.flore-cart-thumb', line);
    var freshThumb = $('.flore-cart-thumb', freshLine);
    if (thumb && freshThumb && thumb.tagName !== freshThumb.tagName) thumb.replaceWith(freshThumb.cloneNode(true));
    var title = $('.flore-cart-line-title', line);
    var freshTitle = $('.flore-cart-line-title', freshLine);
    if (title && freshTitle) {
      if (title.tagName !== freshTitle.tagName) title.replaceWith(freshTitle.cloneNode(true));
      else {
        if (title.textContent !== freshTitle.textContent) title.textContent = freshTitle.textContent;
        if (title.tagName === 'A') title.href = freshTitle.href;
      }
    }
    var variant = $('.flore-cart-line-variant', line);
    var freshVariant = $('.flore-cart-line-variant', freshLine);
    if (freshVariant) {
      if (variant) variant.textContent = freshVariant.textContent;
      else $('.flore-cart-line-controls', line).before(freshVariant.cloneNode(true));
    } else if (variant) variant.remove();
    var quantity = $('[data-qty]', line);
    var freshQuantity = $('[data-qty]', freshLine);
    if (quantity && freshQuantity && quantity.textContent !== freshQuantity.textContent) quantity.textContent = freshQuantity.textContent;
    $all('[data-flore-cart-op]', line).forEach(function (button) {
      var operation = button.dataset.floreCartOp;
      var freshButton = $all('[data-flore-cart-op]', freshLine).find(function (item) {
        return item.dataset.floreCartOp === operation;
      });
      if (freshButton) {
        button.dataset.key = freshButton.dataset.key;
        button.dataset.to = freshButton.dataset.to;
      }
    });
    var price = $('.flore-cart-line-price', line);
    var freshPrice = $('.flore-cart-line-price', freshLine);
    if (price && freshPrice && !moneyDisplayMatches(price, freshPrice)) price.innerHTML = freshPrice.innerHTML;
  }

  function patchFoot(live, fresh) {
    var foot = $('.flore-cart-foot', live);
    var freshFoot = $('.flore-cart-foot', fresh);
    if (!freshFoot) {
      if (foot) foot.remove();
      return;
    }
    if (!foot) {
      live.appendChild(freshFoot.cloneNode(true));
      return;
    }
    foot.hidden = false;
    var subtotal = $('.flore-cart-subtotal-val', foot);
    var freshSubtotal = $('.flore-cart-subtotal-val', freshFoot);
    if (subtotal && freshSubtotal && !moneyDisplayMatches(subtotal, freshSubtotal)) subtotal.innerHTML = freshSubtotal.innerHTML;
    var savings = $('.flore-cart-saved', foot);
    var freshSavings = $('.flore-cart-saved', freshFoot);
    if (freshSavings) {
      if (savings) {
        savings.hidden = false;
        if (savings.textContent !== freshSavings.textContent) savings.textContent = freshSavings.textContent;
      } else $('.flore-cart-fineprint', foot).before(freshSavings.cloneNode(true));
    } else if (savings) savings.remove();
    var fineprint = $('.flore-cart-fineprint', foot);
    var freshFineprint = $('.flore-cart-fineprint', freshFoot);
    if (fineprint && freshFineprint && fineprint.textContent !== freshFineprint.textContent) fineprint.textContent = freshFineprint.textContent;
    var checkout = $('[data-flore-cart-checkout]', foot);
    var freshCheckout = $('[data-flore-cart-checkout]', freshFoot);
    if (checkout && freshCheckout && checkout.textContent !== freshCheckout.textContent) checkout.textContent = freshCheckout.textContent;
    var codes = $('[data-flore-cart-discount-codes]', foot);
    var freshCodes = $('[data-flore-cart-discount-codes]', freshFoot);
    if (codes && freshCodes && codes.innerHTML !== freshCodes.innerHTML) codes.innerHTML = freshCodes.innerHTML;
  }

  function render(html) {
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-flore-cart-inner]');
    var live = $('[data-flore-cart-inner]');
    if (!fresh || !live) return false;
    var oldError = $('.flore-cart-err', live);
    if (oldError) oldError.remove();
    var freshLines = $all('.flore-cart-line', fresh);
    var list = $('.flore-cart-lines', live);
    if (!freshLines.length) {
      if (list) list.remove();
      var oldFoot = $('.flore-cart-foot', live);
      if (oldFoot) oldFoot.remove();
      var freshEmpty = $('.flore-cart-empty', fresh);
      var liveEmpty = $('.flore-cart-empty', live);
      if (freshEmpty) {
        if (liveEmpty) {
          if (liveEmpty.innerHTML !== freshEmpty.innerHTML) liveEmpty.replaceWith(freshEmpty.cloneNode(true));
        } else live.appendChild(freshEmpty.cloneNode(true));
      }
    } else {
      var empty = $('.flore-cart-empty', live);
      if (empty) empty.remove();
      if (!list) {
        list = document.createElement('ul');
        list.className = 'flore-cart-lines';
        list.setAttribute('role', 'list');
        live.appendChild(list);
      }
      list.hidden = false;
      var liveLines = $all('.flore-cart-line', list);
      var used = [];
      freshLines.forEach(function (freshLine, index) {
        var line = liveLines.find(function (candidate) {
          return used.indexOf(candidate) === -1 && candidate.dataset.key === freshLine.dataset.key;
        }) || liveLines.find(function (candidate) {
          return used.indexOf(candidate) === -1 && candidate.dataset.variantId === freshLine.dataset.variantId;
        });
        if (line) {
          used.push(line);
          patchLine(line, freshLine);
        } else line = freshLine.cloneNode(true);
        if (list.children[index] !== line) list.insertBefore(line, list.children[index] || null);
      });
      liveLines.forEach(function (line) { if (used.indexOf(line) === -1) line.remove(); });
      patchFoot(live, fresh);
    }
    var freshTitle = $('.flore-cart-title', fresh);
    var liveTitle = $('.flore-cart-title', live);
    if (freshTitle && liveTitle) liveTitle.dataset.cartHeading = freshTitle.dataset.cartHeading;
    live.setAttribute('data-count', fresh.getAttribute('data-count') || '0');
    updateCount(parseInt(fresh.getAttribute('data-count') || '0', 10));
    return true;
  }

  function fetchSectionHtml() {
    var id = sectionId();
    return fetch(shopRoot() + '?sections=' + encodeURIComponent(id), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { return data[id]; });
  }

  /* Also used when the cart icon opens a drawer changed elsewhere. */
  function refresh() {
    var serial = ++refreshSerial;
    return fetchSectionHtml().then(function (html) {
      if (serial === refreshSerial && !mutationRunning && !queuedMutations.length) render(html);
      return fetch(shopRoot() + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (serial === refreshSerial && !mutationRunning && !queuedMutations.length) syncDiscountCodes(data);
        }).catch(function () {});
    });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  function mutate(path, body) {
    var id = sectionId();
    body.sections = id;
    body.sections_url = shopRoot();
    return post(shopRoot() + path, body).then(function (data) {
      if (data.sections && data.sections[id]) return { html: data.sections[id], cart: data };
      return fetchSectionHtml().then(function (html) { return { html: html, cart: data }; });
    });
  }

  function resolveKey(task) {
    if (!latestSectionHtml || !task.key) return task.key;
    var doc = new DOMParser().parseFromString(latestSectionHtml, 'text/html');
    var lines = $all('.flore-cart-line', doc);
    var exact = lines.find(function (line) { return line.dataset.key === task.key; });
    if (exact) return exact.dataset.key;
    var matching = lines.find(function (line) {
      return line.dataset.variantId === task.variantId;
    });
    return matching ? matching.dataset.key : null;
  }

  function drainMutations() {
    if (mutationRunning) return;
    var task = queuedMutations.shift();
    if (!task) {
      if (latestSectionHtml) render(latestSectionHtml);
      syncDiscountCodes(latestCartData);
      completedCallbacks.splice(0).forEach(function (callback) { callback(); });
      latestSectionHtml = null;
      latestCartData = null;
      pendingFocus = null;
      status('');
      if (checkoutAfterUpdate) {
        checkoutAfterUpdate = false;
        window.location.href = '/checkout';
      }
      return;
    }
    if (task.key) {
      task.body.id = resolveKey(task);
      if (!task.body.id) {
        task.resolves.forEach(function (resolve) { resolve(); });
        drainMutations();
        return;
      }
    }
    mutationRunning = true;
    mutate(task.path, task.body).then(function (result) {
      latestSectionHtml = result.html;
      latestCartData = result.cart;
      if (task.onResponse) completedCallbacks.push(function () { task.onResponse(result.cart); });
      task.resolves.forEach(function (resolve) { resolve(); });
      mutationRunning = false;
      drainMutations();
    }).catch(function (err) {
      task.resolves.forEach(function (resolve) { resolve(); });
      queuedMutations.splice(0).forEach(function (queued) {
        queued.resolves.forEach(function (resolve) { resolve(); });
      });
      mutationRunning = false;
      latestSectionHtml = null;
      latestCartData = null;
      completedCallbacks = [];
      checkoutAfterUpdate = false;
      refresh().catch(function () {}).finally(function () {
        pendingFocus = null;
        status('');
        flash(err && (err.description || err.message) || 'Unable to update the cart. Please try again.');
      });
    });
  }

  function queueMutation(path, body, context) {
    return new Promise(function (resolve) {
      if (path === 'cart/change.js' && context && context.key) {
        var pending = queuedMutations.find(function (task) {
          return task.path === path && task.key === context.key;
        });
        if (pending) {
          pending.body.quantity = body.quantity;
          pending.resolves.push(resolve);
          return;
        }
      }
      queuedMutations.push({
        path: path,
        body: body,
        key: context && context.key,
        variantId: context && context.variantId,
        onResponse: context && context.onResponse,
        resolves: [resolve]
      });
      drainMutations();
    });
  }

  function add(variantId, quantity, product) {
    if (busy || !variantId) return Promise.resolve();
    var count = Math.max(1, parseInt(quantity || '1', 10) || 1);
    refreshSerial++;
    open();
    optimisticCount(count);
    var line = optimisticAddLine(variantId, count, product);
    if (line) optimisticPrice(line, variantId, parseInt($('[data-qty]', line).textContent, 10));
    status('Adding to cart…');
    var emptyMessage = $('.flore-cart-empty p', panel());
    if (emptyMessage) emptyMessage.textContent = product && product.title || 'Your cart';
    return queueMutation('cart/add.js', { id: variantId, quantity: count });
  }

  function buyNow(variantId, quantity) {
    if (busy) return;
    setBusy(true);
    post(shopRoot() + 'cart/add.js', { id: variantId, quantity: quantity || 1 })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (err) { flash(err && err.description); setBusy(false); });
  }

  function change(key, quantity, button) {
    if (busy || !key) return Promise.resolve();
    pendingFocus = button ? { key: key, op: button.getAttribute('data-flore-cart-op') } : null;
    var line = button && button.closest('.flore-cart-line');
    var display = line && $('[data-qty]', line);
    var previous = parseInt(display && display.textContent || '0', 10);
    var next = Math.max(0, quantity);
    refreshSerial++;
    if (display && next > 0) display.textContent = next;
    if (line && next === 0) line.hidden = true;
    optimisticCount(next - previous);
    if (next > 0) optimisticPrice(line, line && line.dataset.variantId, next);
    else {
      optimisticEmpty();
      optimisticSubtotal();
    }
    status('Updating cart…');
    return queueMutation('cart/change.js', { id: key, quantity: next }, {
      key: key,
      variantId: line && line.dataset.variantId
    });
  }

  function applyDiscount(form) {
    var input = $('input[name="discount"]', form);
    var button = $('button[type="submit"]', form);
    var code = input && input.value.trim();
    if (!code) return;
    var existing = discountCodes();
    if (existing.some(function (item) { return item.toLowerCase() === code.toLowerCase(); })) {
      discountFeedback('This discount code is already applied.', true);
      return;
    }
    discountFeedback('', false);
    if (button) button.disabled = true;
    queueMutation('cart/update.js', { discount: existing.concat(code).join(',') }, {
      onResponse: function (data) {
        var result = data && Array.isArray(data.discount_codes) && data.discount_codes.find(function (item) {
          return item.code && item.code.toLowerCase() === code.toLowerCase();
        });
        if (!result || !result.applicable) discountFeedback('This discount code could not be applied.', true);
        else {
          input.value = '';
          discountFeedback('Discount code applied.', false);
        }
      }
    }).then(function () { if (button) button.disabled = false; });
  }

  function removeDiscount(button) {
    var item = button.closest('[data-flore-cart-discount-code]');
    if (!item) return;
    var code = item.dataset.floreCartDiscountCode;
    var remaining = discountCodes().filter(function (value) { return value !== code; });
    item.remove();
    discountFeedback('', false);
    queueMutation('cart/update.js', { discount: remaining.join(',') }, {
      onResponse: function () { discountFeedback('Discount code removed.', false); }
    });
  }

  function flash(msg) {
    if (!msg) return;
    var live = $('[data-flore-cart-inner]');
    if (!live) { window.alert(msg); return; }
    var old = $('.flore-cart-err', live);
    if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'flore-cart-err';
    el.setAttribute('role', 'alert');
    el.textContent = msg;
    live.insertBefore(el, live.firstChild);
    open();
  }

  /* ---- events ---- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-flore-cart-open]');
    if (opener) {
      e.preventDefault();
      open();
      if (!mutationRunning && !queuedMutations.length) {
        refresh().catch(function () { flash('Unable to update the cart. Please try again.'); });
      }
      return;
    }
    var closer = e.target.closest('[data-flore-cart-close]');
    if (closer) {
      // let real links (e.g. the empty-state "Shop" button, line-item links) navigate
      var href = closer.tagName === 'A' ? closer.getAttribute('href') : null;
      if (!href || href.charAt(0) === '#') e.preventDefault();
      close();
      return;
    }
    if (e.target.closest('[data-flore-cart-checkout]')) {
      e.preventDefault();
      if (mutationRunning || queuedMutations.length) checkoutAfterUpdate = true;
      else window.location.href = '/checkout';
      return;
    }

    var discountRemove = e.target.closest('[data-flore-cart-discount-remove]');
    if (discountRemove) {
      e.preventDefault();
      removeDiscount(discountRemove);
      return;
    }

    var changer = e.target.closest('[data-flore-cart-change]');
    if (changer) {
      e.preventDefault();
      var line = changer.closest('.flore-cart-line');
      var quantity = parseInt($('[data-qty]', line).textContent, 10);
      var operation = changer.getAttribute('data-flore-cart-op');
      var next = operation === 'remove' ? 0 : quantity + (operation === 'increase' ? 1 : -1);
      change(changer.getAttribute('data-key'), next, changer);
      return;
    }

    var addBtn = e.target.closest('[data-flore-add]');
    if (addBtn) {
      e.preventDefault();
      var f1 = document.getElementById('flore-buy-form');
      if (f1) add(f1.querySelector('[name="id"]').value, parseInt(f1.querySelector('[name="quantity"]').value || '1', 10));
      return;
    }

    var buyBtn = e.target.closest('[data-flore-buynow]');
    if (buyBtn) {
      e.preventDefault();
      var f2 = document.getElementById('flore-buy-form');
      if (f2) buyNow(f2.querySelector('[name="id"]').value, parseInt(f2.querySelector('[name="quantity"]').value || '1', 10));
      return;
    }

    if (isOpen() && backdrop() && e.target === backdrop()) close();
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });

  /* Fallback: a plain <form action="/cart/add"> submit is intercepted so it
     opens the drawer instead of loading the cart page. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.matches('[data-flore-cart-discount-form]')) {
      e.preventDefault();
      applyDiscount(form);
      return;
    }
    if (form && form.id === 'flore-buy-form') {
      e.preventDefault();
      add(form.querySelector('[name="id"]').value, parseInt(form.querySelector('[name="quantity"]').value || '1', 10));
    }
  });

  window.FloreCart = { open: open, close: close, add: add, buyNow: buyNow, change: change, refresh: refresh };
})();
